// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"f5a17ee2","277":"7b4d50e2"}[chunkId] + ".chunk.css";
};